var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.016,
    height: 18.016,
    viewBox: "0 0 18.016 18.016",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#707070;stroke:#707070;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.8,3.864,13.09.156a.53.53,0,0,0-.749,0L.156,12.34A.529.529,0,0,0,0,12.715v3.709a.53.53,0,0,0,.53.53H4.239a.529.529,0,0,0,.375-.155L16.8,4.613a.53.53,0,0,0,0-.749ZM4.019,15.894H1.058v-2.96L9.8,4.193,12.76,7.153,4.019,15.894ZM13.509,6.4,10.55,3.444l2.165-2.165,2.959,2.959Z",
    transform: "translate(0.5 0.562)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.471e9f93a2ce5cac4f63ba22c3fd76d8.svg";
export { ForwardRef as ReactComponent };